module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/menu"
    }
  }, [_vm._v("Menu")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Menu Harga")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Menu Harga")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('el-row', [_c('el-col', {
    staticClass: "grid-content",
    attrs: {
      "span": 12
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.cari))])]), _vm._v(" "), _c('el-col', {
    staticClass: "grid-content",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("\n                        Sort by  \n                        "), _c('el-select', {
    staticClass: "filter-item",
    staticStyle: {
      "width": "200px"
    },
    on: {
      "change": _vm.handleFilter
    },
    model: {
      value: (_vm.sort),
      callback: function($$v) {
        _vm.sort = $$v
      },
      expression: "sort"
    }
  }, _vm._l((_vm.sortOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.addData()
      }
    }
  }, [_vm._v("Tambah Data")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Wilayah",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.add) ? [_c('el-form', {
          ref: ('form' + scope.$index),
          staticClass: "demo-ruleForm",
          attrs: {
            "model": scope.row,
            "rules": _vm.rules3
          }
        }, [_c('el-form-item', {
          attrs: {
            "prop": "kode_wilayah"
          }
        }, [_c('el-select', {
          attrs: {
            "placeholder": "Pilih Wilayah"
          },
          model: {
            value: (scope.row.kode_wilayah),
            callback: function($$v) {
              _vm.$set(scope.row, "kode_wilayah", $$v)
            },
            expression: "scope.row.kode_wilayah"
          }
        }, _vm._l((_vm.level), function(item) {
          return _c('el-option', {
            key: item.kode,
            attrs: {
              "label": item.nama,
              "value": item.kode
            }
          })
        }), 1)], 1)], 1)] : _c('span', [_vm._v(_vm._s(scope.row.wilayah))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Harga",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.add) ? [_c('el-form', {
          ref: ('form' + scope.$index),
          staticClass: "demo-ruleForm",
          attrs: {
            "model": scope.row,
            "rules": _vm.rules3
          }
        }, [_c('el-form-item', {
          attrs: {
            "prop": "harga"
          }
        }, [_c('el-input', {
          model: {
            value: (scope.row.harga),
            callback: function($$v) {
              _vm.$set(scope.row, "harga", $$v)
            },
            expression: "scope.row.harga"
          }
        })], 1)], 1)] : _c('span', [_vm._v(_vm._s(_vm.toMoney(scope.row.harga)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Pilihan",
      "align": "right",
      "header-align": "right",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.add) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Edit Ingredient",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.confirmEdit2(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.add) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Hapus Ingredient",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDel(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.add) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ok",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "el-icon-check",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.confirmAdd1(scope.$index, scope.row, ('form' + scope.$index))
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.add) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Cancel",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "el-icon-error",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.cancelEdit(scope.$index, scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.tableData.length,
      "page-size": _vm.page_size,
      "current-page": _vm.current_page
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Pegawai",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "status-icon": "",
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nama Toko",
      "prop": "name",
      "disabled": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Level",
      "label-width": _vm.formLabelWidth,
      "prop": "level"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Pegawai"
    },
    model: {
      value: (_vm.form.level),
      callback: function($$v) {
        _vm.$set(_vm.form, "level", $$v)
      },
      expression: "form.level"
    }
  }, _vm._l((_vm.level), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.kode
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmAdd('form')
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Pegawai",
      "visible": _vm.dialogFormWilEdit
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "form1",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form1,
      "status-icon": "",
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Kode",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": ""
    },
    model: {
      value: (_vm.form1.kode),
      callback: function($$v) {
        _vm.$set(_vm.form1, "kode", $$v)
      },
      expression: "form1.kode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form1.name),
      callback: function($$v) {
        _vm.$set(_vm.form1, "name", $$v)
      },
      expression: "form1.name"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilEdit = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1('form1')
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalArea),
      expression: "loadingModalArea"
    }],
    attrs: {
      "title": "Tambah Area",
      "visible": _vm.dialogFormArea
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormArea = $event
      }
    }
  }, [_c('el-form', {
    ref: "form2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form2,
      "status-icon": "",
      "rules": _vm.rules2,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wilayah",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": ""
    },
    model: {
      value: (_vm.form2.name),
      callback: function($$v) {
        _vm.$set(_vm.form2, "name", $$v)
      },
      expression: "form2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nama Area",
      "prop": "area",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.area),
      callback: function($$v) {
        _vm.$set(_vm.form2, "area", $$v)
      },
      expression: "form2.area"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.loadingModalArea = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmArea1('form2')
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Konfirmasi",
      "visible": _vm.dialogFormWilDel
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Apakah Anda yakin akan menghapus harga wilayah " + _vm._s(_vm.nama) + " ?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Ya")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Info",
      "visible": _vm.dialogFormInfo
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fca20c2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/MenuHarga.vue
// module id = 1449
// module chunks = 2